import { Link } from 'react-router-dom';
import { genreShortcuts } from '../../../mocks/movies';

export default function GenreShortcuts() {
  return (
    <section className="w-full px-4 md:px-8 py-10 md:py-14 bg-background-50">
      <div className="flex items-center gap-3 mb-6">
        <span className="w-1 h-6 md:h-7 rounded-full bg-accent-500"></span>
        <h2 className="font-heading font-bold text-lg md:text-2xl text-foreground-950">分类快捷入口</h2>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
        {genreShortcuts.map((item) => (
          <Link
            key={item.label}
            to={`/category/${encodeURIComponent(item.type)}`}
            className="group flex flex-col items-center gap-3 p-5 rounded-lg bg-background-100 border border-background-200 hover:border-primary-300 hover:bg-background-50 transition-all duration-300 cursor-pointer"
          >
            <span className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-50 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
              <i className={`${item.icon} text-2xl`} aria-hidden="true"></i>
            </span>
            <div className="text-center">
              <p className="font-heading font-semibold text-sm text-foreground-950 group-hover:text-primary-600 transition-colors">
                {item.label}
              </p>
              <p className="text-[11px] text-foreground-500 mt-0.5 hidden sm:block">{item.desc}</p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}